import React, { useRef } from 'react';
import styled from 'styled-components';

import { Button } from '../atom/Button';
import { Text } from '../atom/Text';
import { Flex } from '../atom/Layout';
import Icon, { CheckIcon } from '../atom/Icon';
import { TextareaWithCounter } from '../molecules/TextareaWithCounter';
import { ArrowToggle } from '../organism/Toggle';
import PageTemplate from './PageTemplate';
import { ReviewInfo } from '../../user/ReviewPossibleListItem';
import { HorizonGreyLine } from '../atom/HorizonGreyLine';
import ThemeStyle from '../../../lib/style/ThemeStyle';
import { HorizontalPadding, VerticalPadding } from '../atom/Padding';
import ActiveEvaluation from '../organism/ActiveEvaluation';
import { AllowMarketingCheck } from '../organism/AllowMarketing';

const ReviewWriteTemplate = ({
  defaultImages,
  thumbnail,
  itemName,
  createDateTime,
  rate,
  snsUrl,
  text,
  handleMouseOver,
  handleMouseOut,
  handleClick,
  handleClickHashtag,
  handlePostReview,
  handleDeleteDefaultImage,
  handleAddImage,
  handleDeleteAddImage,
  previewReviewImages,
  loading,
  onCheck,
  marketingAgree,
  allowMarketing,
  isShowAllowMarketing,
  handleAllowMarketingCheck,
  rewrite,
  onChange,
  reviewCategoryType,
}) => {
  const reviewImage = useRef([]);

  return (
    <PageTemplate title={`리뷰 ${rewrite ? '수정' : '작성'}`} noMargin>
      <Flex column alignItems="stretch" padding="1.313rem 0 2.5rem">
        <HorizontalPadding padding="20">
          <ReviewInfo
            storageUri={thumbnail}
            itemName={itemName}
            createDateTime={createDateTime}
            rewrite={rewrite}
          />
        </HorizontalPadding>
        <HorizonGreyLine style={{ marginTop: '1.25rem' }} />
        <Flex
          width="100%"
          padding="1.25rem"
          column
          style={{ borderBottom: `${ThemeStyle.color.pinkishGrey} 1px solid` }}
        >
          <Text size={18} weight="medium">
            서비스에 만족하셨나요?
          </Text>
          <ActiveEvaluation
            rate={rate}
            onMouseOut={handleMouseOut}
            onMouseOver={handleMouseOver}
            onClick={handleClick}
          />
        </Flex>
        <Flex width="100%" column>
          <VerticalPadding padding="20">
            <Text size={18} weight="medium">
              어떤 점이 좋았나요?
            </Text>
          </VerticalPadding>
          <Flex column alignItems="stretch" width="100%">
            <ArrowToggle
              titleBackground={ThemeStyle.background.grey}
              descriptionBackground={ThemeStyle.background.grey}
              toggleOnIdx={0}
              content={[
                {
                  title: (
                    <Flex>
                      <Icon iconName="photo_camera" />
                      <Text size={14} style={{ marginLeft: '0.625rem' }}>
                        [필독] 리뷰 작성 시 유의사항
                      </Text>
                    </Flex>
                  ),
                  description: 
                    (reviewCategoryType === 'BABYFACE_AFTER_BIRTH' ? [
                      '후기를 작성해주시면 이벤트에 자동 참여 됩니다 <br />',
                      '(마케팅 수신 동의 필수)<br />',
                      '<br />',
                      '아래 사진을 포함하여 사진을 2장 이상 올려주세요<br />',
                      '- 입체초음파와 베이비페이스 비교사진<br />',
                      '- 아기 얼굴이 잘 보이는 사진<br />',
                      '<br />',
                      '조건에 맞지 않는 후기는 이벤트 참여에서 제외될 수 있습니다',
                    ] : [
                      '사진을 2장 이상 올려주세요<br />',
                      '만삭사진, 아기방 사진 등 베이비페이스와 함께한 소중한 순간을 공유해주시면 더 좋습니다',
                    ]),
                },
              ]}
            />
            <Flex column alignItems="stretch" padding="1.25rem">
              <TextareaWithCounter
                placeholder={`이 곳에 후기를 20자 이상 입력해주세요`}
                name="text"
                value={text || ''}
                onChange={onChange}
                height="9.5rem"
                maxLength={2000}
                rows={3}
              />
              <Flex column alignItems="flex-start" padding="0.438rem 0">
                <Text size={12} color="caption">
                  추천 태그를 클릭 시 해당 태그가 리뷰 내용에 추가됩니다.
                </Text>
                <Flex
                  justifyContent="flex-start"
                  wrap="wrap"
                  padding="0.3rem 0 0"
                >
                  {HASH_TAG.map((tag) => (
                    <Text
                      size={12}
                      color="orangePink"
                      key={tag}
                      lineHeight={1.67}
                      style={{ marginRight: '0.313rem', cursor: 'pointer' }}
                      onClick={handleClickHashtag}
                    >
                      #{tag}
                    </Text>
                  ))}
                </Flex>
              </Flex>
              <Flex column padding="0.187rem 0 0.625rem" alignItems="stretch">
                <Text size={14} weight="medium">
                  사진을 첨부해 주세요.
                </Text>
                <Flex
                  wrap={+true}
                  padding={'0.563rem 0 0.313rem'}
                  justifyContent="start"
                >
                  {defaultImages.map((i) => (
                    <ImageWrapper
                      key={i.id}
                      onClick={(e) => {
                        e.stopPropagation();
                        handleDeleteDefaultImage(i.id);
                      }}
                    >
                      <DeleteIcon>x</DeleteIcon>
                      <ContainImage
                        src={rewrite ? i.image.storageUri : i.storageUri}
                      />
                    </ImageWrapper>
                  ))}
                  {previewReviewImages.map((i, index) => (
                    <ImageWrapper
                      key={index}
                      onClick={(e) => {
                        e.stopPropagation();
                        handleDeleteAddImage(index);
                      }}
                    >
                      <DeleteIcon>ㅡ</DeleteIcon>
                      <ContainImage src={i} />
                    </ImageWrapper>
                  ))}
                  {Array(5 - defaultImages.length - previewReviewImages.length)
                    .fill(0)
                    .map((_, idx) => (
                      <ImageWrapper
                        onClick={() => reviewImage.current[idx].click()}
                        key={idx}
                      >
                        +
                        <input
                          style={{ display: 'none' }}
                          ref={(ref) => (reviewImage.current[idx] = ref)}
                          type="file"
                          accept="image/*"
                          onChange={handleAddImage}
                          multiple={true}
                        />
                      </ImageWrapper>
                    ))}
                </Flex>
                <Text size={12} color="caption">
                  * 사진은 최대 5개 등록할 수 있습니다.
                </Text>
              </Flex>
              {!rewrite && (
                <>
                  <Flex
                    padding="0.625rem 0"
                    onClick={onCheck}
                    alignItems="flex-start"
                  >
                    <CheckIcon
                      defaultBackgroundColor="pinkishGrey"
                      checked={marketingAgree}
                    />
                    <Text
                      size={12}
                      lineHeight="1.67"
                      style={{ margin: '-0.25rem 0 0 0.563rem' }}
                    >
                      작성한 리뷰가 베이비페이스 마케팅 목적으로 사용되는 것에
                      동의합니다.
                    </Text>
                  </Flex>
                  {isShowAllowMarketing && (
                    <>
                      <HorizonGreyLine />
                      <AllowMarketingCheck
                        margin="1.25rem 0 0"
                        allowMarketing={allowMarketing}
                        onClick={() =>
                          handleAllowMarketingCheck(!allowMarketing)
                        }
                      />
                    </>
                  )}
                </>
              )}
            </Flex>
          </Flex>
        </Flex>
        <Button
          onClick={handlePostReview}
          isLoading={loading}
          style={{ width: '12.5rem', height: '2.6rem', alignSelf: 'center' }}
        >
          <Text>리뷰 {rewrite ? '수정' : '등록'}하기</Text>
        </Button>
      </Flex>
    </PageTemplate>
  );
};

export default ReviewWriteTemplate;

const HASH_TAG = [
  '베이비페이스',
  '베이비페이스후기',
  '베이비페이스초음파',
  '만삭사진촬영',
  '베이비샤워',
];

const DeleteIcon = styled(Flex)`
  position: absolute;
  right: 0;
  top: 0;
  width: 1rem;
  height: 1rem;
  border-radius: 0 6px 0;
  background-color: ${({ theme }) => theme.color.caption};
  color: ${({ theme }) => theme.color.background};
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
  font-size: 1rem;
`;

const ContainImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;

const ImageWrapper = styled(Flex)`
  position: relative;
  width: 3.75rem;
  height: 3.75rem;
  background: ${({ theme }) => theme.background.grey};
  font-size: 2rem;
  cursor: pointer;

  & + & {
    margin-left: 0.5rem;
  }

  &,
  img {
    border-radius: 6px;
  }
`;
